import React from 'react';
import styles from './index.module.scss';

const Column = ({ title, children }) => {
  return (
    <div>
      <p className={styles.title}>{title}</p>
      {children}
    </div>
  );
};

export default Column;
